// extracted by mini-css-extract-plugin
module.exports = {"topContent":"CorporateWave_topContent__T53rJ","wave":"CorporateWave_wave__PdIo0","icon":"CorporateWave_icon__NGYKT"};